<!--  -->
<template>
  <div>
    <!-- 新增/编辑 地址 -->
    <eDialog
      :dialog-title="invoiceAddressTitle"
      :center-dialog-visible="dialogFormVisible"
      :popup-width="'800px'"
      @resetPopupData="setResetPopupData"
      @submitPopupData="setSubmitPopupData"
    >
      <div class="add-dialog">
        <el-form
          ref="submitFormRef"
          :model="submitFrom"
          :rules="rules"
          label-width="100px"
        >
          <el-row :gutter="20">
            <!-- <el-col :span="24" v-if="dialogType == 'add'">
              <el-form-item
                label="地址类型:"
                prop="checkedAddr"
                class="chioce-addr"
              >
                <el-checkbox-group
                  v-model="submitFrom.checkedAddr"
                  @change="handleCheckedAddr"
                >
                  <el-checkbox label="2">收货地址</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item label="收件人:" prop="realName">
                <el-input
                  v-model="submitFrom.realName"
                  autocomplete="off"
                  placeholder="请输入收件人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="手机号:" prop="mobile">
                <el-input
                  v-model="submitFrom.mobile"
                  autocomplete="off"
                  placeholder="请输入收件人手机号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="address-wrap">
              <span class="red-flag">*</span>
              <el-form-item label="地址:" prop="addrAll">
                <div class="area-out">
                  <el-form-item prop="province">
                    <el-select
                      v-model="submitFrom.province"
                      placeholder="请选择省份"
                      @change="getCityByAreaId()"
                    >
                      <el-option
                        v-for="provinceItem in provinceArr"
                        :key="provinceItem.areaId"
                        :label="provinceItem.areaName"
                        :value="provinceItem.areaId"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="city">
                    <el-select
                      v-model="submitFrom.city"
                      placeholder="请选择城市"
                      @change="getDistrictByCityId()"
                    >
                      <el-option
                        v-for="cityItem in cityArr"
                        :key="cityItem.areaId"
                        :label="cityItem.areaName"
                        :value="cityItem.areaId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="county">
                    <el-select
                      v-model="submitFrom.county"
                      placeholder="区/县/街道"
                    >
                      <el-option
                        v-for="countyItem in districtArr"
                        :key="countyItem.areaId"
                        :label="countyItem.areaName"
                        :value="countyItem.areaId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="详细地址:" prop="address">
                <el-input
                  v-model="submitFrom.address"
                  type="textarea"
                  placeholder="请填写详细地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="邮政编码:"
                prop="postCode"
                placeholder="请输入邮政编码"
              >
                <el-input
                  v-model="submitFrom.postCode"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="电子邮箱:"
                prop="email"
                placeholder="请输入电子邮箱"
              >
                <el-input
                  v-model="submitFrom.email"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="" class="set-default">
                <el-checkbox v-model="submitFrom.isdefault"
                  >设为默认</el-checkbox
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </eDialog>
  </div>
</template>

<script>
import { mobile, email, postalCode } from '../../../../utils/verification';
import api from '../../../../api/evaluation/index';
import eDialog from '../../../../../../components/common/e-dialog.vue';

export default {
  components: { eDialog },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    invoiceAddressTitle: {
      type: String,
      default: '添加新地址',
    },
    // 反显数据
    details: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      provinceArr: [],
      cityArr: [],
      districtArr: [],
      submitFrom: {
        // checkedAddr: [],
        realName: '',
        mobile: '',
        address: '',
        province: '',
        city: '',
        county: '', // 区县
        addrAll: '',
        postCode: '',
        email: '',
        isdefault: false,
        isShare: 2,
      },
      rules: {
        // checkedAddr: [
        //   {
        //     required: true,
        //     message: '请至少选择一个地址类型',
        //     trigger: 'blur',
        //   },
        // ],
        realName: [
          {
            required: true,
            message: '请输入收件人姓名',
            trigger: ['blur', 'change'],
          },
        ],
        mobile: [
          {
            required: true,
            validator: mobile,
            trigger: ['blur', 'change'],
          },
        ],

        province: [
          {
            required: true,
            message: '请填写省份',
            // validator: checkedAddr,
            trigger: ['blur', 'change'],
          },
        ],
        city: [
          {
            required: true,
            message: '请填写城市',
            // validator: checkedAddr,
            trigger: ['blur', 'change'],
          },
        ],
        county: [
          {
            required: true,
            message: '请填写区县',
            // validator: checkedAddr,
            trigger: ['blur', 'change'],
          },
        ],
        address: [
          {
            required: true,
            message: '请输入收件人详细地址',
            trigger: ['blur', 'change'],
          },
        ],
        postCode: [
          {
            required: true,
            validator: postalCode,
            trigger: ['blur', 'change'],
          },
        ],
        email: [
          {
            validator: (rule, value, callback) => {
              email(rule, value, callback, false, false);
            },
            // validator: email(),
            trigger: ['blur', 'change'],
          },
        ],
      },
    };
  },

  computed: {},

  created() {},
  methods: {
    setResetPopupData() {
      this.resetForm('submitFormRef');
      this.$emit('resetPopupData');
    },
    // 地址类型选择
    handleCheckedAddr() {
      // if (this.submitFrom.checkedAddr.length == 2) {
      //   this.addFlag = "addAll";
      // } else {
      // this.addFlag = this.submitFrom.checkedAddr[0];
      this.addFlag = this.submitFrom.checkedAddr?.[0] ?? null;
      // }
    },
    // 获取省份信息
    async getAreaByCountryCode(parentId) {
      const para = {
        parentAreaId: parentId,
      };
      console.log(parentId);
      const res = await api.queryByParentId(para);
      if (res.code === '200') {
        this.provinceArr = res.data;
      }
    },
    // 获取城市信息
    async getCityByAreaId(province = '') {
      this.submitFrom.city = province === '' ? '' : this.submitFrom.city;
      this.submitFrom.county = province === '' ? '' : this.submitFrom.county;
      const para = {
        parentAreaId: province === '' ? this.submitFrom.province : province,
      };
      const res = await api.queryByParentId(para);
      if (res.code === '200') {
        this.cityArr = res.data;
      }
    },
    // 获取区县信息
    async getDistrictByCityId(city = '') {
      this.submitFrom.county = city === '' ? '' : this.submitFrom.county;
      const para = {
        parentAreaId: city === '' ? this.submitFrom.city : city,
      };
      const res = await api.queryByParentId(para);
      if (res.code === '200') {
        this.districtArr = res.data;
      }
    },
    // 提交   handleType = ''  handleType   新增：add   修改：''
    setSubmitPopupData() {
      // let handleType = this.dialogType == 'add' ? 'add' : '';
      this.$refs.submitFormRef.validate((valid) => {
        if (valid) {
          const para = {
            address: this.submitFrom.address, // 收件地址
            postcode: this.submitFrom.postCode, // 邮政编码
            mobile: this.submitFrom.mobile, // 手机号
            isDefault: this.submitFrom.isdefault ? 1 : 0, // 是否设置默认地址
            email: this.submitFrom.email, // 邮箱地址
            realName: this.submitFrom.realName, // 收件人
            // invoiceOrMemberType: this.submitFrom.checkedAddr.toString(), //	地址类型(1： 收发票地址 2：收货地址)	是	[string]
            location: `${this.submitFrom.province},${this.submitFrom.city},${this.submitFrom.county}`, //	所在地区（取地区编号，用逗号分隔）
            // option: handleType, //操作标识
            isShare: 2,
            addressid:
              this.submitFrom.addressid === undefined
                ? ''
                : this.submitFrom.addressid,
          };
          this.addOrUpdateInvoiceAddress(para);
        } else {
          return false;
        }
        return true;
      });
    },
    async addOrUpdateInvoiceAddress(params) {
      let res = {};
      if (this.invoiceAddressTitle === '添加新地址') {
        res = await api.addInvoiceAddress(params);
      }
      if (res.code === '200') {
        this.$emit('submitPopupData');
        this.resetForm('submitFormRef');
        this.$message({
          type: 'success',
          message: '提交成功!',
        });
      }
    },
    resetForm(formName) {
      this.submitFrom = {
        // checkedAddr: [],
        realName: '',
        mobile: '',
        address: '',
        province: '',
        city: '',
        county: '', // 区县
        addrAll: '',
        postCode: '',
        email: '',
        isdefault: false,
        isShare: 2,
      };
      this.$refs[formName].resetFields();
    },
    // 修改 收货地址
    rowEditHandle(dt, type) {
      // this.editAddressInfo = dt;
      // this.chooseAddress = dt;
      // this.addressId = dt.addressId;
      // this.dialogType = "edit";
      this.submitFrom = {
        checkedAddr: type,
        realName: dt.realName,
        mobile: dt.mobile,
        address: dt.address,
        addressid: dt.addressId,
        province: parseInt(dt.provinceAreaId, 10),
        city: parseInt(dt.cityAreaId, 10),
        county: parseInt(dt.countryAreaId, 10), // 区县
        addrAll: `${dt.provinceAreaId},${dt.cityAreaId},${dt.countryAreaId}`,
        postCode: dt.postCode,
        email: dt.email || '',
        isdefault: parseInt(dt.isdefault, 10) === 1,
      };
      // console.log(this.submitFrom);
      this.getAreaByCountryCode();
      this.getCityByAreaId(dt.provinceAreaId);
      this.getDistrictByCityId(dt.cityAreaId);
    },
    // 新增、修改地址
    // OrderAddInfoHandle(para) {
    //   Api.OrderAddInfoHandle(para).then((res) => {
    //     if (res.status) {
    //       Promise.all([this.getAddressList()]).then(() => {
    //         this.addFlag = '';
    //         if (this.dialogType == 'add') {
    //           let param = 'submitFormRef';
    //           this.$refs[param].resetFields();
    //         }
    //         this.dialogType = '';
    //       });
    //       this.$message({
    //         type: 'success',
    //         message: '提交成功!',
    //       });
    //       this.resetForm('submitFrom', 'clear');
    //     } else {
    //       this.$message({
    //         type: 'info',
    //         message: res.message,
    //       });
    //     }
    //   });

    //   this.dialogFormVisible = false;
    //   this.showMask = false;
    // },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input__inner {
  height: 30px;
  line-height: 30px;
  border-radius: 0;
}
::v-deep.el-dialog__body {
  padding: 20px 60px 0 20px;
  .el-textarea__inner,
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__content {
    line-height: 1;
    margin-top: 4px;
  }
  .el-form-item__label {
    height: 30px;
    line-height: 30px;
  }
  .el-input__icon {
    height: 30px;
    line-height: 30px;
  }
}
.add-dialog {
  .address-wrap {
    position: relative;
    .red-flag {
      position: absolute;
      left: 56px;
      top: 6px;
      color: #f56c6c;
    }
  }

  .dialog-footer {
    padding: 0;
    margin-top: 0;
    .e-btn {
      height: 30px;
      line-height: 28px;
      box-sizing: border-box;
    }
  }

  ::v-deep.el-dialog__footer {
    padding-top: 0;
  }
  .area-out {
    display: flex;
    justify-content: space-between;
    .el-form-item + .el-form-item {
      margin-left: 10px;
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
